import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    clienteId: 0,
    cliente: null,
    clienteNombre: null,
    nombre: '',
    tipoEventoId: 0,
    tipoEvento: null,
    tipoEventoNombre: null,
    fechaSorteo: moment(new Date()).format('YYYY-MM-DD'),
    rowVersion: null,

    sorteado: false,
};

const mutations = {
    updateField,

    'INICIALIZAR_SORTEO_GLOBAL' (state, sorteoGlobalId) {
        state.id = sorteoGlobalId;
        state.clienteId = 0;
        state.cliente = null;
        state.clienteNombre = null;
        state.nombre = '';
        state.tipoEventoId = 0;
        state.tipoEvento = null;
        state.tipoEventoNombre = null;
        state.fechaSorteo = moment(new Date()).format('YYYY-MM-DD'),
        state.rowVersion = null;

        state.sorteado = false;
    },
    'SET_SORTEO_GLOBAL' (state, sorteoGlobal) {
        state.clienteId = sorteoGlobal.cliente? sorteoGlobal.cliente.id : 0;
        state.cliente = sorteoGlobal.cliente;
        state.clienteNombre = sorteoGlobal.cliente? sorteoGlobal.cliente.nombre.trim() : null;
        state.nombre = sorteoGlobal.nombre.trim();
        state.tipoEventoId = sorteoGlobal.tipoEvento? sorteoGlobal.tipoEvento.id : 0;
        state.tipoEvento = sorteoGlobal.tipoEvento;
        state.tipoEventoNombre = sorteoGlobal.tipoEvento? sorteoGlobal.tipoEvento.nombre.trim() : null;
        state.fechaSorteo = moment(sorteoGlobal.fechaSorteo).format('YYYY-MM-DD'),
        state.rowVersion = sorteoGlobal.rowVersion;

        state.sorteado = (/true/i).test(sorteoGlobal.sorteado);
    },
    'SET_CLIENTE'(state, cliente) {
        state.cliente = cliente;
        if (cliente) {
            state.clienteId = cliente.id? cliente.id : 0;
            state.clienteNombre = cliente.nombre? cliente.nombre.trim() : null;
        } else {
            state.clienteId = 0;
            state.clienteNombre = null;
        }
    },
    'SET_TIPO_EVENTO'(state, tipoEvento) {
        state.tipoEvento = tipoEvento;
        if (tipoEvento) {
            state.tipoEventoId = tipoEvento.id? tipoEvento.id : 0;
            state.tipoEventoNombre = tipoEvento.nombre? tipoEvento.nombre.trim() : null;
        } else {
            state.tipoEventoId = 0;
            state.tipoEventoNombre = null;
        }
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, sorteoGlobalId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SORTEO_GLOBAL', sorteoGlobalId);

            if (sorteoGlobalId != 0) {
                /* Recuperamos los datos del evento */
                apiAxios.get('sorteosglobales/' + sorteoGlobalId + '/abm' ) 
                    .then(res => {
                        commit('SET_SORTEO_GLOBAL', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (save) {
                let sorteoGlobal= {
                    clienteId: parseInt(state.clienteId),
                    nombre: state.nombre.toUpperCase().trim(),
                    tipoEventoId: parseInt(state.tipoEventoId),
                    fechaSorteo: moment(state.fechaSorteo).format('YYYY-MM-DD'),
                };

                let url = 'sorteosglobales';
                if (state.id != 0) {
                    url += '/' + state.id;
                    sorteoGlobal.rowVersion = state.rowVersion;
                }

                apiAxios.post(url, sorteoGlobal)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    setCliente: ({commit}, cliente) => {
        commit('SET_CLIENTE', cliente);
    },
    setTipoEvento: ({commit}, tipoEvento) => {
        commit('SET_TIPO_EVENTO', tipoEvento);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}